(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.dataset.quantityBreakSwatches) {
    document.documentElement.dataset.quantityBreakSwatches = 'true';
    document.addEventListener('change', (event) => {
      const swatch = event.target.closest('[data-quantity-break-swatch]');
      if (swatch) {
        const fieldset = swatch.closest('[data-native-select-id]');
        const select = fieldset && document.getElementById(fieldset.dataset.nativeSelectId);
        if (!select || select.value === swatch.value) return;
        event.stopPropagation();
        select.value = swatch.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const select = event.target.closest('.quantity-breaks--variant-swatches .quantity-break__variant-select');
      if (!select) return;
      const fieldset = document.querySelector(`[data-native-select-id="${CSS.escape(select.id)}"]`);
      if (!fieldset) return;
      const radio = Array.from(fieldset.querySelectorAll('[data-quantity-break-swatch]')).find((input) => input.value === select.value);
      if (radio) radio.checked = true;
      const currentValue = fieldset.querySelector('[data-quantity-break-current-value]');
      if (currentValue) currentValue.textContent = select.options[select.selectedIndex]?.text || select.value;
      fieldset.querySelectorAll('[data-quantity-break-swatch]').forEach((input) => {
        const option = Array.from(select.options).find((item) => item.value === input.value);
        input.disabled = !option || option.disabled || option.hidden;
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
